// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as ResponsiveImage$LiveRoom from "../../ResponsiveImage.bs.js";

var container = Curry._1(Css.style, {
      hd: Css.width(Css.pct(100.0)),
      tl: {
        hd: Css.position(Css.relative),
        tl: {
          hd: Css.before({
                hd: Css.unsafe("content", "\"\""),
                tl: {
                  hd: Css.display(Css.block),
                  tl: {
                    hd: Css.paddingTop(Css.pct(100.0)),
                    tl: /* [] */0
                  }
                }
              }),
          tl: {
            hd: Css.overflow(Css.hidden),
            tl: {
              hd: Css.cursor("pointer"),
              tl: {
                hd: Css.borderRadius(Css.px(2)),
                tl: {
                  hd: Css.width(Css.px(40)),
                  tl: {
                    hd: Css.height(Css.px(40)),
                    tl: /* [] */0
                  }
                }
              }
            }
          }
        }
      }
    });

var imageStyle = Curry._1(Css.style, {
      hd: Css.width(Css.pct(100.0)),
      tl: {
        hd: Css.height(Css.pct(100.0)),
        tl: {
          hd: Css.unsafe("objectFit", "contain"),
          tl: /* [] */0
        }
      }
    });

var wrapper = Curry._1(Css.style, {
      hd: Css.position(Css.absolute),
      tl: {
        hd: Css.top(Css.zero),
        tl: {
          hd: Css.left(Css.zero),
          tl: {
            hd: Css.right(Css.zero),
            tl: {
              hd: Css.bottom(Css.zero),
              tl: /* [] */0
            }
          }
        }
      }
    });

var imageNotSelected = Curry._1(Css.merge, {
      hd: Curry._1(Css.style, {
            hd: Css.border(Css.px(2), Css.solid, Css.transparent),
            tl: {
              hd: Css.boxSizing(Css.borderBox),
              tl: /* [] */0
            }
          }),
      tl: {
        hd: container,
        tl: /* [] */0
      }
    });

var imageSelected = Curry._1(Css.merge, {
      hd: Curry._1(Css.style, {
            hd: Css.border(Css.px(2), Css.solid, Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlack_nohashtag)),
            tl: {
              hd: Css.boxSizing(Css.borderBox),
              tl: /* [] */0
            }
          }),
      tl: {
        hd: container,
        tl: /* [] */0
      }
    });

function getImageClassName(isSelected) {
  if (isSelected) {
    return imageSelected;
  } else {
    return imageNotSelected;
  }
}

function LotThumbnail(props) {
  var className = props.className;
  var isSelected = props.isSelected;
  var index = props.index;
  var onImageSelected = props.onImageSelected;
  var index$1 = index !== undefined ? index : 0;
  var isSelected$1 = isSelected !== undefined ? isSelected : false;
  var className$1 = className !== undefined ? className : "";
  return React.createElement("button", {
              className: Curry._1(Css.merge, {
                    hd: isSelected$1 ? imageSelected : imageNotSelected,
                    tl: {
                      hd: Curry._1(Css.style, {
                            hd: Css.background(Css.none),
                            tl: /* [] */0
                          }),
                      tl: {
                        hd: className$1,
                        tl: /* [] */0
                      }
                    }
                  }),
              onClick: (function (param) {
                  Curry._1(onImageSelected, index$1);
                })
            }, React.createElement("div", {
                  className: wrapper
                }, React.createElement(ResponsiveImage$LiveRoom.make, {
                      imageRenditions: props.imageRenditions,
                      alt: props.lotTitle,
                      sizes: props.sizes,
                      className: imageStyle
                    })));
}

var make = LotThumbnail;

export {
  container ,
  imageStyle ,
  wrapper ,
  imageNotSelected ,
  imageSelected ,
  getImageClassName ,
  make ,
}
/* container Not a pure module */
